const setupSegments = (entries) => {
  const segments = {};
  for (const entry of entries) {
    const quadrantIndex = entry.quadrant.index;
    const ringIndex = entry.ring.index;
    let quadrantData = {};
    if (quadrantIndex !== void 0) {
      if (segments[quadrantIndex] === void 0) {
        segments[quadrantIndex] = {};
      }
      quadrantData = segments[quadrantIndex];
    }
    let ringData = [];
    if (ringIndex !== void 0) {
      if (quadrantData[ringIndex] === void 0) {
        quadrantData[ringIndex] = [];
      }
      ringData = quadrantData[ringIndex];
    }
    ringData.push(entry);
  }
  return segments;
};
const getSegment = (segmented, quadrant, ring, ringOffset = 0) => {
  const quadrantIndex = quadrant.index;
  const ringIndex = ring.index;
  const segmentedData = quadrantIndex === void 0 ? {} : segmented[quadrantIndex] || {};
  return ringIndex === void 0 ? [] : segmentedData[ringIndex + ringOffset] || [];
};

export { getSegment, setupSegments };
//# sourceMappingURL=utils.esm.js.map
